import {RootState} from "../../../setup";

const getDevices = () => ({devices: {devices}}: RootState) => devices
const getSelectedDeviceId = () => ({devices: {selectedDeviceId}}: RootState) => selectedDeviceId

export const devicesSelectors = {
    getDevices,
    getSelectedDeviceId
}